import { theme } from './theme';

export const adminStyles = {
  layout: {
    container: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6",
    header: "bg-white shadow-sm border-b border-stone-200/70",
    content: "bg-background min-h-screen",
    sidebar: "bg-secondary w-64 fixed inset-y-0 left-0 transform transition-transform duration-300 ease-in-out",
  },
  
  colors: {
    ...theme.colors,
    admin: {
      primary: '#FFB800',
      secondary: '#1A1A1A',
      accent: '#FF4081',
      success: '#4CAF50',
      warning: '#FFC107',
      error: '#F44336',
      info: '#2196F3',
    }
  },

  components: {
    card: {
      base: "bg-white rounded-2xl border border-stone-200/70 shadow-sm hover:shadow-md transition-shadow duration-200",
      header: "px-4 sm:px-5 py-3.5 border-b border-stone-100",
      content: "p-4 sm:p-5",
      footer: "px-4 sm:px-5 py-3.5 bg-stone-50 rounded-b-2xl",
    },
    
    button: {
      base: "px-3.5 py-1.5 rounded-lg text-sm font-medium transition-colors duration-200",
      primary: "bg-primary text-white hover:bg-primary-dark",
      secondary: "bg-gray-200 text-gray-800 hover:bg-gray-300",
      danger: "bg-red-500 text-white hover:bg-red-600",
    },
    
    input: {
      base: "w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary",
      error: "border-red-500 focus:ring-red-500",
      success: "border-green-500 focus:ring-green-500",
    },
    
    table: {
      container: "w-full bg-white rounded-xl overflow-hidden",
      header: "bg-gray-50 text-left text-sm font-medium text-gray-500 uppercase tracking-wider",
      row: "border-t border-gray-200 hover:bg-gray-50",
      cell: "px-6 py-4 whitespace-nowrap text-sm text-gray-900",
    },
    
    modal: {
      overlay: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4",
      container: "bg-white rounded-2xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto",
      header: "px-4 sm:px-5 py-3.5 border-b border-stone-100",
      content: "p-4 sm:p-5",
      footer: "px-4 sm:px-5 py-3.5 bg-stone-50 border-t border-stone-100",
    },
    
    notification: {
      base: "fixed bottom-4 right-4 p-4 rounded-lg shadow-lg max-w-md",
      success: "bg-green-500 text-white",
      error: "bg-red-500 text-white",
      info: "bg-blue-500 text-white",
      warning: "bg-yellow-500 text-white",
    }
  },

  typography: {
    ...theme.fonts,
    heading: {
      h1: "text-2xl font-bold text-secondary",
      h2: "text-xl font-bold text-secondary",
      h3: "text-lg font-bold text-secondary",
      h4: "text-base font-bold text-secondary",
    }
  },

  effects: {
    transition: "transition-all duration-200 ease-in-out",
    hover: "hover:shadow-lg hover:scale-105",
    active: "active:scale-95",
  }
}; 